import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useFormContext } from "@/context/form";
import { useNavigate } from "react-router-dom";

const Modal: React.FC = () => {
  const navigate = useNavigate();
  const isModalOpen = useFormContext((state) => state.isModalOpen);
  const setModal = useFormContext((state) => state.setModal);
  const id = useFormContext((state) => state.id);

  const onClose = () => {
    setModal(false);
  };

  const onCancel = () => {
    navigate(-1);
    setModal(false);
  };

  return (
    <Dialog open={isModalOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="m-auto">Unsaved changes</DialogTitle>
          <DialogDescription>
            You have made changes that haven't been saved. If you leave now,
            your progress will be lost. Do you still want to proceed?
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center gap-2">
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" form={id}>
            Save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
